import { ContentLibraryMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ContentLibraryMenu/ContentLibraryMenu";

export { ContentLibraryMenu };
